/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/ChooseLocation/Support/Locations/Error"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-2-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-3-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-4-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-5-4QcjJ': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-6-4QcjJ': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-7-4QcjJ': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-8-4QcjJ': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--mt-9-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-10-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="Locations couldn't be fetched. Please try again."
/>
</div>
{children}
</React.Fragment>)
}